import React, { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { colors } from '../../constants/theme';
import MatchCard from '../Common/MatchCard';
import UpcomingMatches from './UpcomingMatches';
import { matchesService } from '../../services/api';

const MatchesView = ({ matches, onMatchesUpdate }) => {
  const [loading, setLoading] = useState(false);

  const handleRefresh = async () => {
    setLoading(true);
    try {
      // Se tiver função de callback, usar ela
      if (onMatchesUpdate) {
        await onMatchesUpdate();
      } else {
        // Senão, tentar carregar direto
        const response = await matchesService.getCurrent();
        console.log('Partidas atualizadas:', response);
      }
    } catch (error) {
      console.error('Erro ao atualizar partidas:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header das partidas atuais */}
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold" style={{ color: colors.primary }}>
          Partidas em Andamento
        </h2>
        <button
          onClick={handleRefresh}
          disabled={loading}
          className="flex items-center space-x-2 px-4 py-2 bg-white hover:bg-gray-50 rounded-lg disabled:opacity-50 border"
        >
          <RefreshCw className={`h-4 w-4 ${loading ? 'animate-spin' : ''}`} />
          <span>{loading ? 'Atualizando...' : 'Atualizar'}</span>
        </button>
      </div>
      
      {/* Partidas em andamento */}
      <div className="grid gap-6">
        {matches && matches.length > 0 ? (
          matches.map((match) => (
            <MatchCard
              key={match.id}
              match={match}
              isOrganizer={false}
            />
          ))
        ) : (
          <div className="bg-white p-8 rounded-lg shadow text-center">
            <p className="text-gray-500 mb-2">Nenhuma partida em andamento</p>
            <p className="text-sm text-gray-400">
              As partidas aparecerão aqui quando forem iniciadas
            </p>
          </div>
        )}
      </div>

      {/* Divisor visual */}
      <div className="border-t border-gray-200 my-8"></div>

      {/* Próximas partidas */}
      <div>
        <UpcomingMatches />
      </div>
    </div>
  );
};

export default MatchesView;